export default {
  PRIMARY: "Avenir Next",
  CONSIGNER: "'Inter', sans-serif",
};
